enum ACTIONS {
    FETCH_USERS = '[USERS] Fetch all',
    UPDATE_USER = '[USERS] Update user'
}

export default ACTIONS;

export enum FETCH_USERS {
    REQUEST = 'FETCH_USERS_REQUEST',
    SUCCESS = 'FETCH_USERS_SUCCESS',
    FAILURE = 'FETCH_USERS_FAILURE'
}

export enum FETCH_USERS_DATASET {
    REQUEST = 'FETCH_USERS_DATASET_REQUEST',
    SUCCESS = 'FETCH_USERS_DATASET_SUCCESS',
    FAILURE = 'FETCH_USERS_DATASET_FAILURE'
}

export enum BLOCK_USER {
    REQUEST = 'BLOCK_USER_REQUEST',
    SUCCESS = 'BLOCK_USER_SUCCESS',
    FAILURE = 'BLOCK_USER_FAILURE'
}

export enum UNBLOCK_USER {
    REQUEST = 'UNBLOCK_USER_REQUEST',
    SUCCESS = 'UNBLOCK_USER_SUCCESS',
    FAILURE = 'UNBLOCK_USER_FAILURE'
}

export enum FETCH_USER_PERMISSIONS {
    REQUEST = 'FETCH_USER_PERMISSIONS_REQUEST',
    SUCCESS = 'FETCH_USER_PERMISSIONS_SUCCESS',
    FAILURE = 'FETCH_USER_PERMISSIONS_FAILURE'
}

export enum USER {
    ADD_PERMISSION = 'ADD_PERMISSION',
    DELETE_PERMISSION = 'DELETE_PERMISSION',
    RESET_PERMISSION = 'RESET_PERMISSION'
}

export enum SAVE_USER_PERMISSIONS {
    REQUEST = 'SAVE_USER_PERMISSIONS_REQUEST',
    SUCCESS = 'SAVE_USER_PERMISSIONS_SUCCESS',
    FAILURE = 'SAVE_USER_PERMISSIONS_FAILURE'
}

export enum FETCH_USER {
    REQUEST = 'FETCH_USER_REQUEST',
    SUCCESS = 'FETCH_USER_SUCCESS',
    FAILURE = 'FETCH_USER_FAILURE'
}